import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router'
import { Articles, SectionMeta } from 'ion-article-cmp'
import WingBanners from '../components/WingBanners'
import { getSectionLabel } from 'ion-sections'
import { fetchAuthor } from '../../store/author'
import Ad from '../components/Ad'
import FORMATS from '../components/AdFormats'
import { MobileElse } from 'ion-media'
import Sidebar from '../components/Sidebar'
import NoImage from '../static/no-image.png'
import ArticleCard from '../components/ArticleCard'
import NotFound from './NotFound'
import MagazineCover from '../components/MagazineCover'
import AuthorBio from '../components/AuthorBio'

const AuthorArticles = ({ articles, sectionLabel, noImage, moreButton }) => {
  const title = 'Articles by ' + sectionLabel
  return (
    <>
      <Helmet title={title}>
        <meta property='og:title' content={title} />
        <meta itemProp='headline' content={title} />
        <meta name='twitter:title' content={title} />
      </Helmet>
      {articles.map((article) => {
        return (
          <ArticleCard key={article.contentKey} article={article} noImage={noImage} />
        )
      })}
      {moreButton}
    </>
  )
}

class AuthorSectionPage extends (React.Component) {
  constructor (props) {
    super(props)
    props.fetchAuthor(props.authorSlug)
  }

  render () {
    const props = this.props
    return (
      <>
        <Helmet
          titleTemplate='%s'
          title={props.title || getSectionLabel(props.section)}
        >
          <meta property='og:type' content='section' />
          <meta name='description' content={props.description} />
          <meta itemProp='description' content={props.description} />
          <meta property='og:description' content={props.description} />
          <meta property='og:url' content={props.url} />
          <meta property='keywords' content={props.keywords} />
          <meta name='twitter:description' content={props.description} />
        </Helmet>
        <WingBanners useSmall={props.useSmall} isConnected={props.isConnected} location={props.location} onSlotRenderEndedLeft={props.onSlotRenderEndedLeft} onSlotRenderEndedRight={props.onSlotRenderEndedRight} />
        <Ad isConnected={props.isConnected} path={`/${process.env.RAZZLE_DFP_CODE}/${props.section}`} slotId='leaderboard-1' targeting={{ leaderboard: '1' }} collapseEmptyDiv className='advert-leaderboard-1' {...FORMATS.leaderboard} />
        <div className='wrapper article-listing'>
          {props.isPage0 &&
            <div className='author article-list'>
              {props.author && props.author.author &&
                <AuthorBio {...props.author.author} noImage={NoImage} />}
              <Articles {...props} component={AuthorArticles} section={props.section} count={15} pageSize={14} noImage={NoImage} notFound={NotFound} withMore />
            </div>}
          {!props.isPage0 &&
            <div className='author article-list'>
              <Articles className='article-list paged' {...props} component={AuthorArticles} section={props.section} page0Limit={15} pageSize={14} noImage={NoImage} notFound={NotFound} withMore />
            </div>}
          <Sidebar {...props}>
            <MagazineCover />
          </Sidebar>
        </div>
        <MobileElse>
          <Ad isConnected={props.isConnected} path={`/${process.env.RAZZLE_DFP_CODE}/${props.section}`} slotId='leaderboard-3' targeting={{ leaderboard: '3' }} collapseEmptyDiv className='advert-leaderboard-3' {...FORMATS.leaderboard} />
        </MobileElse>
        <SectionMeta {...props} />
      </>
    )
  }
}

AuthorSectionPage.defaultProps = {
  section: 'authors/molife-kumona'
}

const mapDispatchToProps = (dispatch) => bindActionCreators({ fetchAuthor }, dispatch)

export default withRouter(connect((state) => ({ articles: state.articles, author: state.author }), mapDispatchToProps)(AuthorSectionPage))
